/* Steadypet theme — small vanilla helpers. No dependencies. */

(function () {
  "use strict";

  /* Rotating announcement bar */
  function announcements() {
    var items = document.querySelectorAll(".announce__item");
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove("is-active");
      i = (i + 1) % items.length;
      items[i].classList.add("is-active");
    }, 4000);
  }

  /* Accordion ("A Brand That Cares", product details) */
  function accordions() {
    document.querySelectorAll(".acc__btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var item = btn.closest(".acc__item");
        var open = item.classList.contains("is-open");
        var group = item.parentElement;
        group.querySelectorAll(".acc__item").forEach(function (el) {
          el.classList.remove("is-open");
        });
        if (!open) item.classList.add("is-open");
      });
    });
  }

  /* Newsletter popup — shows once per session, after a short delay */
  function popup() {
    var box = document.querySelector("[data-popup]");
    if (!box) return;
    var seen = sessionStorage.getItem("sp_popup");
    if (!seen) {
      setTimeout(function () {
        box.classList.add("is-open");
      }, 6000);
    }
    box.addEventListener("click", function (e) {
      if (e.target === box || e.target.hasAttribute("data-popup-close")) {
        box.classList.remove("is-open");
        sessionStorage.setItem("sp_popup", "1");
      }
    });
  }

  /* Product gallery thumbnails */
  function gallery() {
    var main = document.querySelector("[data-gallery-main]");
    if (!main) return;
    document.querySelectorAll("[data-gallery-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        main.src = t.dataset.full || t.src;
      });
    });
  }

  /* Mobile nav */
  function burger() {
    var btn = document.querySelector(".header__burger");
    var nav = document.querySelector(".header__nav");
    if (!btn || !nav) return;
    btn.addEventListener("click", function () {
      var open = nav.style.display === "flex";
      nav.style.display = open ? "" : "flex";
      nav.style.flexDirection = "column";
      nav.style.position = "absolute";
      nav.style.top = "100%";
      nav.style.left = "0";
      nav.style.right = "0";
      nav.style.background = "#fff";
      nav.style.padding = "18px 24px";
      nav.style.borderBottom = "1px solid var(--line)";
    });
  }

  /* Variant picker — swatches drive the real <select name="id"> */
  function variants() {
    var root = document.querySelector("[data-variant-picker]");
    if (!root) return;

    var dataEl = root.querySelector("[data-variant-data]");
    var select = root.querySelector("[data-variant-select]");
    var addBtn = root.querySelector("[data-add-button]");
    if (!dataEl || !select) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var groups = root.querySelectorAll(".variant-swatches");
    var priceEl = document.querySelector(".pdp__price");
    var mainImg = document.querySelector("[data-gallery-main]");

    function selected() {
      return Array.prototype.map.call(groups, function (g) {
        var active = g.querySelector(".is-active");
        return active ? active.dataset.optionValue : null;
      });
    }

    function update() {
      var chosen = selected();
      var match = data.variants.filter(function (v) {
        return chosen.every(function (val, i) {
          return val === null || v.options[i] === val;
        });
      })[0];
      if (!match) return;

      select.value = match.id;
      select.dispatchEvent(new Event("change", { bubbles: true }));

      if (priceEl) {
        priceEl.innerHTML =
          match.price +
          (match.compare_at_price && match.compare_at_price !== match.price
            ? " <s>" + match.compare_at_price + "</s>"
            : "");
      }
      if (mainImg && match.image) mainImg.src = match.image;
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? "Add to cart" : "Sold out";
      }
    }

    groups.forEach(function (g) {
      g.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-option-value]");
        if (!btn) return;
        g.querySelectorAll("[data-option-value]").forEach(function (b) {
          b.classList.remove("is-active");
        });
        btn.classList.add("is-active");
        update();
      });
    });
  }

  /* Video carousel — scroll-snap track with arrow buttons */
  function carousels() {
    document.querySelectorAll("[data-carousel]").forEach(function (root) {
      var track = root.querySelector("[data-carousel-track]");
      if (!track) return;

      function step() {
        var slide = track.querySelector(".carousel__slide");
        return slide ? slide.offsetWidth + 18 : 260;
      }

      var prev = root.querySelector("[data-carousel-prev]");
      var next = root.querySelector("[data-carousel-next]");
      if (prev) prev.addEventListener("click", function () { track.scrollLeft -= step(); });
      if (next) next.addEventListener("click", function () { track.scrollLeft += step(); });

      /* only one video plays at a time */
      track.addEventListener(
        "play",
        function (e) {
          track.querySelectorAll("video").forEach(function (v) {
            if (v !== e.target) v.pause();
          });
        },
        true
      );
    });
  }

  /* Cart drawer — reads /cart.js, opens on cart icon and after add-to-cart */
  function cartDrawer() {
    var drawer = document.querySelector("[data-drawer]");
    if (!drawer) return;

    var itemsEl = drawer.querySelector("[data-drawer-items]");
    var totalEl = drawer.querySelector("[data-drawer-total]");
    var shipEl = drawer.querySelector("[data-drawer-ship]");
    var countEl = drawer.querySelector("[data-drawer-count]");
    var discEl = drawer.querySelector("[data-drawer-discounts]");
    var checkout = drawer.querySelector("[data-drawer-checkout]");

    /* reward ladder — must mirror the automatic discounts set up in Shopify */
    var TIERS = [
      { at: 5000, label: "Free shipping" },
      { at: 10000, label: "€10 off" },
      { at: 15000, label: "€20 off" },
    ];

    function money(cents) {
      return "€" + (cents / 100).toFixed(2).replace(".", ",");
    }

    function ladder(total) {
      var max = TIERS[TIERS.length - 1].at;
      var pct = Math.min(100, (total / max) * 100);
      var reached = TIERS.filter(function (t) { return total >= t.at; });
      var next = TIERS.filter(function (t) { return total < t.at; })[0];

      var head = next
        ? "Spend " + money(next.at - total) + " more for " + next.label
        : "🎉 Everything unlocked!";
      if (reached.length && next) {
        head = "🎉 " + reached[reached.length - 1].label + " unlocked! " + head;
      }

      var pins = TIERS.map(function (t) {
        var on = total >= t.at ? " is-on" : "";
        return (
          '<span class="drawer__pin' + on + '" style="left:' + (t.at / max) * 100 + '%">' +
          "<i></i><em>" + t.label + "</em></span>"
        );
      }).join("");

      return (
        head +
        '<span class="drawer__bar"><i style="width:' + pct + '%"></i>' + pins + "</span>"
      );
    }

    function render(cart) {
      if (countEl) countEl.textContent = cart.item_count;

      if (!cart.items.length) {
        itemsEl.innerHTML = '<p class="sub">Your cart is empty.</p>';
        shipEl.innerHTML = "";
      } else {
        itemsEl.innerHTML = cart.items
          .map(function (i) {
            return (
              '<div class="drawer__line">' +
              (i.image ? '<img src="' + i.image + '" alt="">' : "") +
              "<div><strong>" + i.product_title + "</strong>" +
              (i.variant_title ? "<small>" + i.variant_title + "</small>" : "") +
              "<small>" + money(i.final_price) + "</small></div>" +
              '<span class="drawer__qty">×' + i.quantity + "</span>" +
              "</div>"
            );
          })
          .join("");
        shipEl.innerHTML = ladder(cart.total_price);
      }

      /* automatic discounts Shopify has already applied to the cart */
      if (discEl) {
        var d = (cart.cart_level_discount_applications || []).concat(
          cart.discount_applications || []
        );
        var seen = {};
        var rows = d
          .filter(function (x) {
            if (!x || !x.total_allocated_amount || seen[x.title]) return false;
            seen[x.title] = 1;
            return true;
          })
          .map(function (x) {
            return (
              '<div class="drawer__disc"><span>🏷 ' + x.title + "</span><b>−" +
              money(x.total_allocated_amount) + "</b></div>"
            );
          });
        discEl.innerHTML = rows.join("");
        discEl.hidden = rows.length === 0;
      }

      totalEl.textContent = money(cart.total_price);
      if (checkout) checkout.href = cart.items.length ? "/checkout" : "/collections/all";
    }

    /* one-click upsell inside the drawer */
    var upsellBtn = drawer.querySelector("[data-upsell-add]");
    if (upsellBtn) {
      upsellBtn.addEventListener("click", function () {
        var id = upsellBtn.dataset.variantId;
        var label = upsellBtn.textContent;
        upsellBtn.disabled = true;
        upsellBtn.textContent = "Adding…";
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
        })
          .then(refresh)
          .finally(function () {
            upsellBtn.disabled = false;
            upsellBtn.textContent = label;
          });
      });
    }

    function refresh() {
      return fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {
          itemsEl.innerHTML = '<p class="sub">Could not load your cart.</p>';
        });
    }

    function open() {
      drawer.hidden = false;
      /* setTimeout rather than rAF: rAF is paused in background tabs */
      setTimeout(function () { drawer.classList.add("is-open"); }, 10);
      document.body.style.overflow = "hidden";
      refresh();
    }

    function close() {
      drawer.classList.remove("is-open");
      document.body.style.overflow = "";
      setTimeout(function () { drawer.hidden = true; }, 250);
    }

    document.querySelectorAll("[data-cart-open]").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        open();
      });
    });
    drawer.querySelectorAll("[data-drawer-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !drawer.hidden) close();
    });

    /* intercept add-to-cart so the drawer opens instead of a page jump */
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var label = btn ? btn.textContent : "";
        if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
        fetch("/cart/add.js", { method: "POST", body: new FormData(form) })
          .then(function () { open(); })
          .catch(function () { form.submit(); })
          .finally(function () {
            if (btn) { btn.disabled = false; btn.textContent = label; }
          });
      });
    }
  }

  /* bundle radio cards on the product page */
  function bundlePicker() {
    var group = document.querySelector(".bundles");
    if (!group) return;
    group.addEventListener("click", function (e) {
      var label = e.target.closest(".bundle");
      if (!label) return;
      group.querySelectorAll(".bundle").forEach(function (b) {
        b.classList.remove("is-active");
      });
      label.classList.add("is-active");
      var radio = label.querySelector("input");
      if (radio) radio.checked = true;
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    announcements();
    accordions();
    popup();
    gallery();
    burger();
    variants();
    carousels();
    cartDrawer();
    bundlePicker();
  });
})();
